import styled from 'styled-components';
import media from 'components/mixins/media';
import { secondaryFont } from 'components/mixins/typography';
import { transparentize } from 'utils/color';

const containerMobileStyleBlock = `font-size: 12px;`;

export const Container = styled.div.attrs({
  'data-test': 'question-pool-pagination'
})`
  ${secondaryFont};
  color: ${props => transparentize(props.theme.colors.textColor, 0.4)};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;

  ${media.mobile} ${containerMobileStyleBlock}
`;
